import { render, staticRenderFns } from "./StandardNavigationWrapper.vue?vue&type=template&id=737e6696"
import script from "./StandardNavigationWrapper.vue?vue&type=script&lang=ts"
export * from "./StandardNavigationWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports